// ============================================================
// BenchTableBar - the bench covers the table, which keeps running
// underneath; this bar says what is happening there (whose turn, a
// reaction somebody owes and how long they have) and takes you back to it.
// Going back keeps the draft: the bench steps aside, and a small button on
// the table brings it back.
// ============================================================
import styles from '../../styles/WeaponBench.module.css';

export interface TableFacts {
  /** The round and who acts, when the turn tracker runs. */
  round: number | null;
  acting: string | null;
  /** A reaction somebody owes now, and the seconds left on it. */
  owed: { name: string; seconds: number | null } | null;
}

export default function BenchTableBar({ facts, onBack }: { facts: TableFacts; onBack: () => void }) {
  const turn = facts.round ? `Round ${facts.round}${facts.acting ? ` · ${facts.acting} acts` : ''}` : 'The table';
  return (
    <div className={styles.tableBar} role="region" aria-label="The table">
      <button type="button" className={styles.primary} onClick={onBack} data-testid="bench-back">
        ◂ Back to the table
      </button>
      <span className={styles.tableTurn}>{turn}</span>
      {facts.owed && (
        <span className={styles.tableOwed} role="status" data-testid="bench-owed">
          {facts.owed.name} must react{facts.owed.seconds != null ? ` · ${facts.owed.seconds} s` : ''}
        </span>
      )}
    </div>
  );
}

/** On the table while the bench is set aside: the way back to it. */
export function BenchReturn({ name, onReturn }: { name: string; onReturn: () => void }) {
  return (
    <button type="button" className={styles.return} onClick={onReturn} data-testid="bench-return">
      Editing {name || 'a weapon'} · Return
    </button>
  );
}
